import React from 'react';
import PropTypes from 'prop-types';
import { observer } from 'mobx-react';
import { analytics } from 'core/analytics';
import { withNamespaces } from 'react-i18next';

import Tooltip from 'components/Tooltip';

import {
  LikeContainer,
  LikesCount,
  HeartIcon,
} from 'apps/content/views/like.styles';

const Like = withNamespaces()(
  observer(({ content }) => {
    const contentType = content.contentType
      ? content.contentType.toLowerCase()
      : 'unknown-content';
    function like() {
      content.Like();
      analytics.sendEvent(`liked-${contentType}`);
    }
    function unLike() {
      content.UnLike();
      analytics.sendEvent(`unliked-${contentType}`);
    }
    return (
      <LikeContainer active={content.isLiked && true}>
        <Tooltip delayShow={500} id='tooltipLike' />
        <HeartIcon
          size='small'
          name={content.isLiked ? 'liked' : 'unliked'}
          onClick={content.isLiked ? unLike : like}
          data-tip='Likes'
          data-for='tooltipLike'
        />
        <LikesCount>{content.likesCount}</LikesCount>
      </LikeContainer>
    );
  }),
);

Like.propTypes = {
  content: PropTypes.object,
};

export default Like;
